<div floatLabel="never" [formGroup]="form">
  <div class="autocomplete-input flex flex-row">
    <input type="text" matInput appNoHtmlTags trim [formControlName]="controlName" [matAutocomplete]="auto">
    <button mat-button [ngStyle]="{'visibility': (selectControl.value) ? 'visible' : 'hidden'}" mat-icon-button
      aria-label="" (click)="selectControl.setValue('')" [disabled]="selectControl.disabled">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayDevice">
    <mat-option *ngIf="loading" disabled>
      <mat-spinner diameter="18"></mat-spinner>&nbsp; Loading devices…
    </mat-option>
    <mat-option *ngIf="!loading && (filteredDevices$ | async)?.length === 0" disabled>
      No available devices found.
      <button mat-button color="primary" (click)="$event.stopPropagation(); selectControl.setValue(selectControl.value);">Refresh</button>
    </mat-option>
  <mat-option class="autoCompleteSystem" *ngFor="let d of filteredDevices$ | async" [value]="d.edgeDeviceId">
      <span>{{ d.edgeDeviceId }}</span>
    </mat-option>
  </mat-autocomplete>
</div>
